module.exports = __webpack_public_path__ + "img/fcst_video_thumb.8833637f.jpg";